<style lang="scss" scoped>
@import '$vars';

a {
  position: fixed;
  bottom: 0;
  right: 2em;
  background: $color-red;
  padding: 5px 15px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  color: white;
  box-shadow: -4px 5px 5px rgba(0,0,0,0.3);
  font-size: 0.7rem;
  display: flex;
  text-decoration: none;
  z-index: 10;
}
p {
  margin: 0
}
figure {
  width: 1.5em;
}

.window-timer {
  &__wrapper {
    align-items: center;
    display: flex;
    justify-content: space-between;
  }

  &__icon {
    box-sizing: border-box;
    margin-right: 0.5rem;
  }

  &__timer,
  &__label {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  &__label {
    &:before {
      content: '\2011';
      margin: 0 0.45rem;
    }
  }
}
</style>

<template>
  <router-link
    v-if="loaded && getActiveAppointment"
    v-show="parseInt($route.params.agendaId) !== getActiveAppointment.id"
    :to="`/doctor/appointments/${getActiveAppointment.patientType}/${getActiveAppointment.user.id}/${getActiveAppointment.id}`"
    class="window-timer"
  >
    <div class="window-timer__wrapper">
      <dr-icon class="window-timer__icon" name="dashDuracao" fill="white" />

      <drTimer class="window-timer__timer" />

      <span class="window-timer__label">Consulta em andamento</span>
    </div>
  </router-link>
</template>

<script>
import drTimer from '@/components/timer'

export default {
  components: {
    drTimer
  },
  data () {
    return {
      loaded: false,
      appointment: null,
      timerInterval: null,
      patientType: 'patient'
    }
  },
  computed: {
    getActiveAppointment () {
      return this.$store.getters.getActiveAppointments[0] || null
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.$http.get(`/${this.fn_GET_PARENT_ROUTE(this.$route)}/agenda/in_progress`, this.$store.getters.getAuthHeader).then((res) => {
        const { data } = res.data
        for (let index in data) {
          data[index].patientType = 'patient'
          if (data[index].special_patient) {
            data[index].patientType = 'specialPatient'
            data[index].user = data[index].special_patient
          }
        }
        if (!this.$store.getters.getActiveAppointments[0]) {
          this.$store.dispatch('setActiveAppointments', data)
        }
      }
      ).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.fn_HIDE_PROGRESS()
        this.loaded = true
        this.$emit('loaded', true)
      })
    }
  }
}
</script>
